import { Component, OnInit } from '@angular/core';
import { ServiceDashboardService } from 'src/app/portal/service-dashboard/service-dashboard.service';
import { AuthenticationService } from 'src/app/user/authentication.service';
import { User } from 'src/app/user/user';
import { TextMessageHistory } from 'src/app/software-services/website-package/text-message-history';

@Component({
    selector: 'website-dashboard',
    templateUrl: './website-dashboard.component.html',
    styleUrls: ['./website-dashboard.component.scss'],
    standalone: false
})
export class WebsiteDashboardComponent implements OnInit {
  public user: User;
  public textMessageTotalCost: number = 0;

  constructor(private auth: AuthenticationService, public dashboardService: ServiceDashboardService) { 
    this.user = this.auth.getCurrentUser();
  }

  ngOnInit(): void {
    debugger;//jeb need to do this somewhere else??  it doesn't seem to work all the time
    this.dashboardService?.website?.textMessageHistory?.forEach((txt: TextMessageHistory) => {
      this.textMessageTotalCost += +txt.price;
    });
  }
}
